import { Dispatch } from 'redux'
import { addPlanIdForAccount } from '../../../apis/planApi'
import { Action, ActionType, RecipeType } from '../../../types/planType'

interface PostPlanType {
  subscriptionId: string
  planId: string
  planObject?: object | undefined
  noOfPacks: number | undefined
  packSize: number | undefined
  weeks: number | undefined
  isDefaultPlan: boolean
  packType: string
  fixedOrCustomPlan: string
}

export const populateRecipeAndTreatData = (payload: any) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.POPULATE_RECIPE_AND_TREATS,
      payload
    })
  }
}

export const populateTreatDataOnly = (payload: any) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.POPULATE_TREATS_ONLY,
      payload
    })
  }
}

export const postPlanId = ({
  subscriptionId,
  planId,
  noOfPacks,
  packSize,
  weeks,
  isDefaultPlan,
  packType,
  fixedOrCustomPlan
}: PostPlanType) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.ADD_ACCOUNT_PLAN_PENDING
    })
    try {
      const success = await addPlanIdForAccount(subscriptionId, planId, noOfPacks as number)

      //console.log(success)

      dispatch({
        type: ActionType.ADD_ACCOUNT_PLAN_SUCCESS,
        payload: { plan: success, noOfPacks, packSize, weeks, isDefaultPlan, packType, fixedOrCustomPlan }
      })
    } catch (_err) {
      dispatch({
        type: ActionType.ADD_ACCOUNT_PLAN_FAIL
      })
    }
  }
}

export const getPlanId = ({ plan, noOfPacks, packSize, weeks, isDefaultPlan, packType, fixedOrCustomPlan }: any) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.ADD_ACCOUNT_PLAN_PENDING
    })
    try {
      //const success = await addPlanIdForAccount(planId, noOfPacks as number)
      dispatch({
        type: ActionType.ADD_ACCOUNT_PLAN_SUCCESS,
        payload: { plan, noOfPacks, packSize, weeks, isDefaultPlan, packType, fixedOrCustomPlan }
      })
    } catch (_err) {
      dispatch({
        type: ActionType.ADD_ACCOUNT_PLAN_FAIL
      })
    }
  }
}

export const postPlanIdForCustom = ({
  subscriptionId,
  planId,
  noOfPacks,
  packSize,
  weeks,
  isDefaultPlan,
  packType,
  fixedOrCustomPlan
}: PostPlanType) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.ADD_ACCOUNT_CUSTOM_PLAN_PENDING
    })
    try {
      const success = await addPlanIdForAccount(subscriptionId, planId, noOfPacks as number)

      //console.log({success})

      dispatch({
        type: ActionType.ADD_ACCOUNT_CUSTOM_PLAN_SUCCESS,
        payload: { plan: success, noOfPacks, packSize, weeks, isDefaultPlan, packType, fixedOrCustomPlan }
      })
    } catch (_err) {
      dispatch({
        type: ActionType.ADD_ACCOUNT_CUSTOM_PLAN_FAIL
      })
    }
  }
}

export const postPlanIdForTrial = ({
  planId,
  planObject,
  noOfPacks,
  packSize,
  weeks,
  isDefaultPlan,
  packType,
  fixedOrCustomPlan
}: PostPlanType) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.ADD_ACCOUNT_PLAN_PENDING
    })
    try {
      dispatch({
        type: ActionType.ADD_ACCOUNT_PLAN_SUCCESS,
        payload: { plan: planObject, noOfPacks, packSize, weeks, isDefaultPlan, packType, fixedOrCustomPlan }
      })
    } catch (_err) {
      dispatch({
        type: ActionType.ADD_ACCOUNT_PLAN_FAIL
      })
    }
  }
}

export const prefillRecipes = (recipes: RecipeType[]) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.PREFILL_ACCOUNT_RECIPES,
      payload: recipes
    })
  }
}

export const addRecipes = (recipes: RecipeType[]) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.ADD_ACCOUNT_RECIPES_PENDING
    })
    try {
      dispatch({
        type: ActionType.ADD_ACCOUNT_RECIPES_SUCCESS,
        payload: recipes
      })
    } catch (_err) {
      dispatch({
        type: ActionType.ADD_ACCOUNT_RECIPES_FAIL
      })
    }
  }
}

export const removeRecipes = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.REMOVE_ACCOUNT_RECIPES_PENDING
    })
    try {
      dispatch({
        type: ActionType.REMOVE_ACCOUNT_RECIPES_SUCCESS,
        payload: []
      })
    } catch (_err) {
      dispatch({
        type: ActionType.REMOVE_ACCOUNT_RECIPES_FAIL
      })
    }
  }
}

export const removeAddons = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.REMOVE_ACCOUNT_ADDONS_PENDING
    })
    try {
      dispatch({
        type: ActionType.REMOVE_ACCOUNT_ADDONS_SUCCESS
      })
    } catch (_err) {
      dispatch({
        type: ActionType.REMOVE_ACCOUNT_ADDONS_FAIL
      })
    }
  }
}

export const prefillAddons = (addons: RecipeType[] | any) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.PREFILL_ACCOUNT_TREATS,
      payload: addons
    })
  }
}

export const addAddons = (addons: RecipeType[] | any) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.ADD_ACCOUNT_ADDONS_PENDING
    })
    try {
      dispatch({
        type: ActionType.ADD_ACCOUNT_ADDONS_SUCCESS,
        payload: addons
      })
    } catch (_err) {
      dispatch({
        type: ActionType.ADD_ACCOUNT_ADDONS_FAIL
      })
    }
  }
}

export const updatePlanEditedStatus = (status: boolean) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_ACCOUNT_PLAN_EDITED_STATUS,
      payload: status
    })
  }
}

export const updateChangedStatus = (status: boolean) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_ACCOUNT_CHANGE_STATUS,
      payload: status
    })
  }
}

export const resetErrorMessage = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.RESET_ERROR_MESSAGE
    })
  }
}

export const resetFlowPlan = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.RESET
    })
  }
}
